var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlGreenFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3704 13.456L26.3161 13.3825L26.3053 13.361L21.3757 6.04297L16.446 13.361L16.4357 13.3816L16.381 13.456C15.59 14.5273 15.1719 15.8 15.1719 17.1368C15.1719 20.5576 17.9549 23.3405 21.3756 23.3405C24.7963 23.3405 27.5794 20.5575 27.5794 17.1368C27.5795 15.8 27.1614 14.5271 26.3704 13.456Z",
    fill: "#92B893"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3763 25.4586C16.79 25.4586 13.0588 21.7274 13.0588 17.1411C13.0588 15.3582 13.6142 13.6594 14.6652 12.2266L17.9058 7.41587L12.91 0L2.5013 15.4514C0.864775 17.6785 0 20.319 0 23.0899C0 30.2086 5.79144 36 12.9101 36C19.6551 36 25.2077 30.8003 25.772 24.1989C24.4958 24.9967 22.9891 25.4586 21.3763 25.4586Z",
    fill: "#92B893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlGreenFive);
export default __webpack_public_path__ + "static/media/al-green-five.4562dde7243ac3e89dd7b70c5548b40f.svg";
export { ForwardRef as ReactComponent };